import React from 'react';

import { CollapsibleAddOnsHeader } from './add-ons/collapsible-header';
import { ManageAddOns } from './add-ons/manage-add-ons';
import { Collapsible } from './collapsible/collapsible';
import { SectionIds } from './constants';
import { CollapsiblePlanSubscriptionHeader } from './plan-subscription/collapsible-header';
import { CollapsiblePlanUsersHeader } from './plan-users/collapsible-header';
import { EditAccountUsersContent } from './plan-users/edit-users';
import { CollapsibleYourCarriersHeader } from './your-carriers/collapsible-header';
import { YourCarriersSelectionToggle } from './your-carriers/selection-toggle';
import { PlanGridConfig, useManageSubscriptionDrawerSectionVisibility } from './use-manage-subscription-drawer-section-visibility';
import { useEnableAddOnCentral } from '../../../../../feature-flags/hooks/use-enable-add-on-central';
import { useIsNonWalletAccessVisible } from '../../../../../hooks/non-wallet-access-hooks';
import { NewLineupPlanGrid } from '../new-lineup-plan-grid/new-lineup-plan-grid';
import { PlanGrid } from '../plan-grid';
import { SimplifiedPlanGrid } from '../simplified-plan-grid';

/**
 * @param {object} props
 * @param {(billingPlanId: string) => void} props.onSelectPlan
 * @param {import('./use-manage-subscription-drawer-section-visibility').PlanGridConfigType} [props.planGridConfig]
 * @param {string} [props.legacyGridClassName]
 * @param {boolean} [props.isMergedWithTabs]
 * @returns {React.JSX.Element}
 */
export const PlanGridLoader = ({ legacyGridClassName, onSelectPlan, planGridConfig: planGridConfigOverride, isMergedWithTabs }) => {
  const shouldShowByoaToggle = useIsNonWalletAccessVisible();
  const isAddOnCentralEnabled = useEnableAddOnCentral();
  const { planGridConfig: planGridConfigFromHook } = useManageSubscriptionDrawerSectionVisibility();

  const planGridConfig = planGridConfigOverride ?? planGridConfigFromHook;

  if (planGridConfig === PlanGridConfig.GbbLineup) {
    return <NewLineupPlanGrid isMergedWithTabs={isMergedWithTabs} onSelectPlan={onSelectPlan} />;
  }

  // These sections only show when NOT on GbbLineup grid
  const shouldShowCarriersSection = shouldShowByoaToggle;
  const shouldShowAddOnsSection = isAddOnCentralEnabled;
  const shouldHidePrice = planGridConfig !== PlanGridConfig.StandardLegacy;

  const gridContent =
    planGridConfig === PlanGridConfig.SimplifiedLegacy ? (
      <SimplifiedPlanGrid onSelectPlan={onSelectPlan} />
    ) : (
      <Collapsible
        className={legacyGridClassName}
        headerContent={<CollapsiblePlanSubscriptionHeader />}
        sectionContent={<PlanGrid onSelectPlan={onSelectPlan} />}
        sectionId={SectionIds.SubscriptionPlan}
      />
    );

  return (
    <>
      {gridContent}
      <Collapsible
        headerContent={<CollapsiblePlanUsersHeader shouldHidePrice={shouldHidePrice} />}
        sectionContent={<EditAccountUsersContent />}
        sectionId={SectionIds.Users}
      />
      {shouldShowCarriersSection ? (
        <Collapsible
          headerContent={<CollapsibleYourCarriersHeader shouldHidePrice={shouldHidePrice} />}
          sectionContent={<YourCarriersSelectionToggle />}
          sectionId={SectionIds.Carriers}
        />
      ) : null}
      {shouldShowAddOnsSection ? (
        <Collapsible
          headerContent={<CollapsibleAddOnsHeader shouldHidePrice={shouldHidePrice} />}
          sectionContent={<ManageAddOns />}
          sectionId={SectionIds.Addons}
        />
      ) : null}
    </>
  );
};
